<template>
  <div class="media-item-container">
    <v-icon>
      <slot name="icon"></slot>
    </v-icon>
    <div class="video-details">
      <div class="video-name">
        <slot name="name"></slot>
      </div>
    </div>
    <v-icon class="clock">
      <slot name="clock"></slot>
    </v-icon>
    <div class="video-details">
      <div class="video-duration">
        <slot name="duration"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaItem'
}
</script>
<style lang="scss" scoped>
.media-item-container {
  display: flex;
  align-items: center;
  padding: 10px;
  .v-icon {
    font-size: 16px;
  }
  .video-details {
    margin-left: 10px;
    .video-name {
      font-weight: 500;
    }
    .video-duration {
      color: #ccc;
      font-size: 12px;
    }
  }
}
.video-list {
  .media-item-container {
    padding-left: 0;
    .video-name {
      font-weight: bold;
    }
  }
}
</style>
